<div class="card-head">
  <div class="card-title">Best Hedge <app-info infoIndex="30"></app-info></div>
  <div class="card-tools">
    <mat-slide-toggle [(ngModel)]="ignoreConstraints" (change)="onIgnoreConstraintsChange()" color="primary"
      class="constraints-toggle">
      Ignore constraints
    </mat-slide-toggle>
  </div>
</div>

@if (isLoading) {
  <div class="best-hedge-loading">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Loading best hedge data…</p>
  </div>
}

@if (!isLoading) {
  @if (rankingItems.length === 0) {
    <div class="best-hedge-empty">
      <mat-icon>insights</mat-icon>
      <p>No data available.</p>
    </div>
  }

  @if (rankingItems.length > 0) {
    <!-- Asset selector -->
    <div class="best-hedge-selector">
      <mat-form-field appearance="outline" class="asset-select-field">
        <mat-label>Select Asset</mat-label>
        <mat-select [value]="selectedTicker" (selectionChange)="onAssetChange($event.value)">
          @for (item of rankingItems; track item.ticker) {
            <mat-option [value]="item.ticker">
              {{ item.name }} ({{ item.ticker }}) — Potential Drop: {{ formatPct(item.risk_reduction_potential) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Risk Sensitivity Chart -->
    <div class="best-hedge-chart-wrapper">
      @if (chartLoaded) {
        <highcharts-chart [options]="chartOptions" [update]="false" constructorType="chart"
          (chartInstance)="onChartInstance($event)" style="width: 100%; height: 420px; display: block;">
        </highcharts-chart>
      }
      @if (!chartLoaded) {
        <div class="chart-loading">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }
    </div>

    <!-- Ranking Table -->
    <div class="best-hedge-table-wrapper">
      <div class="section-title">Risk-Reduction Ranking</div>

      <mat-table [dataSource]="tableDataSource" class="best-hedge-table">

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Asset</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="currentWeight">
          <mat-header-cell *matHeaderCellDef>Current Weight</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ formatPct(row.current_weight, 2) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="currentPfRisk">
          <mat-header-cell *matHeaderCellDef>Current PF Risk</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ formatPct(row.current_pf_risk, 2) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bestHedgeWeight">
          <mat-header-cell *matHeaderCellDef>Best Hedge Weight</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ formatPct(row.best_hedge_weight, 0) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bestHedgePfRisk">
          <mat-header-cell *matHeaderCellDef>Best Hedge PF Risk</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ formatPct(row.best_hedge_pf_risk, 2) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="riskReductionPotential">
          <mat-header-cell *matHeaderCellDef>Risk Reduction</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span [ngClass]="getRiskClass(row.risk_reduction_potential)">
              {{ formatPct(row.risk_reduction_potential, 2) }}
            </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected-row]="row.ticker === selectedTicker"
          (click)="onAssetChange(row.ticker)" class="hedge-table-row">
        </mat-row>

      </mat-table>
    </div>

    <div class="best-hedge-bottom-row">
      @if (portfolioImpactRows.length > 0) {
        <div class="best-hedge-impact-wrapper">
          <div class="section-title">Portfolio Impact</div>
          <table class="exp-table">
            <thead>
              <tr>
                <th></th>
                <th>Current</th>
                <th>Best Hedge</th>
                <th>Change</th>
              </tr>
            </thead>
            <tbody>
              @for (row of portfolioImpactRows; track row.label) {
                <tr>
                  <td class="impact-row-label">{{ row.label }}</td>
                  <td class="num">{{ row.current }}</td>
                  <td class="num">{{ row.bestHedge }}</td>
                  <td class="num">{{ row.change }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (assetImpacts.length > 0) {
        <div class="best-hedge-impact-wrapper">
          <div class="section-title">Pro-rata Weight Impact</div>
          <ul class="impact-list">
            @for (impact of assetImpacts; track impact.ticker) {
              <li class="impact-item">
                <span class="impact-name">{{ impact.name }}
                  <span class="ticker">{{ impact.ticker }}</span>
                </span>
                <span class="impact-weights">
                  {{ formatPct(impact.old_weight, 2) }} → {{ formatPct(impact.new_weight, 2) }}
                </span>
                <span class="impact-delta" [ngClass]="impact.delta >= 0 ? 'delta-positive' : 'delta-negative'">
                  {{ impact.delta >= 0 ? '+' : '' }}{{ formatPct(impact.delta, 2) }}
                </span>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }
}
